import React from "react";
import "../css/home.css";
import { Link, Redirect } from "react-router-dom";

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="homeScreen">
        <div className="container homeContainer">
          <div className="row">
            <div className="col-12 headerColumn">
              <h2>404</h2>
              <h3>Not Found</h3>
            </div>
            <div className="col-12">
              <Link to="/" className="btn-enter">
                Return Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ErrorPage;
